module.exports = "//static.hsappstatic.net/website-grader-ui/static-1.8700/img/favicon-dark.png"